import { OwcTypography, OwcChip } from "@one/react";
import PropTypes from "prop-types";
import { formatUserDisplay } from "../../../../utils/helpers/text";

const BookedForUsers = ({ bookedForEmails, usersList }) => {
  if (!bookedForEmails?.length) {
    return null;
  }

  const users = usersList.map((item) => ({
    ...item,
    key: item.email,
    value: formatUserDisplay(item),
  }));

  // Find users that match the emails
  const bookedForUsers = bookedForEmails
    .map((email) => users.find((user) => user.email === email))
    .filter((user) => user !== undefined);

  if (!bookedForUsers.length) {
    return null;
  }

  return (
    <>
      <OwcTypography variant="caption" style={{ padding: "3px 0" }}>
        Booking for
      </OwcTypography>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        {bookedForUsers.map((user) => (
          <OwcChip
            key={user.email}
            outlined
            style={{ backgroundColor: '#F5F5F2' }}
            round
            icon="user"
            iconType="outlined"
            size="small"
          >
            {user.value}
          </OwcChip>
        ))}
      </div>
    </>
  );
};

BookedForUsers.propTypes = {
  bookedForEmails: PropTypes.arrayOf(PropTypes.string),
  usersList: PropTypes.arrayOf(PropTypes.shape({
    email: PropTypes.string.isRequired,
    givenName: PropTypes.string,
    familyName: PropTypes.string,
    name: PropTypes.string
  })).isRequired
};

export default BookedForUsers;
